import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ToastStyledContainer() {
  return <ToastContainer hideProgressBar pauseOnFocusLoss />;
}
